export const EMAIL_TAKEN_MESSAGE = "Ett konto med denna e-postadress finns redan. Logga in i stället.";
const EMAIL_CHECK_FAILED_MESSAGE = "Ett fel uppstod vid kontroll av e-postadressen";

/**
 * The server's own Swedish text for a throttled lookup, so the user hears
 * "wait a moment" instead of a generic failure. Matched on the tRPC error
 * code structurally — this package does not depend on @trpc/client.
 */
function rateLimitMessage(error) {
  if (typeof error !== "object" || error === null) return undefined;
  const {
    data,
    message
  } = error;
  return data?.code === "TOO_MANY_REQUESTS" && typeof message === "string" ? message : undefined;
}

/** Minimal shape of the tRPC client this needs — avoids importing the router type. */

/**
 * The first sign-up step's gate.
 *
 * Lives here because both entry points — the /skapa-konto page and the login
 * modal — have to answer identically. The modal used to stub this out with
 * `success: true`, so an address that already had an account sailed through to
 * the details step and only failed after the user had filled the whole form in.
 */
export async function checkEmailAvailability(client, email) {
  try {
    const {
      exists
    } = await client.email.checkEmail.query({
      email
    });
    if (exists) {
      return {
        success: false,
        message: EMAIL_TAKEN_MESSAGE
      };
    }
    return {
      success: true,
      message: ""
    };
  } catch (error) {
    console.error("Failed to check email:", error);
    return {
      success: false,
      message: rateLimitMessage(error) ?? EMAIL_CHECK_FAILED_MESSAGE
    };
  }
}